var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "d-flex justify-center w-100",
      attrs: { id: _vm.rootElementId },
    },
    [
      _c(
        "div",
        { staticClass: "d-flex", style: { width: _vm.size + "px" } },
        [
          _c(
            "el-table",
            {
              staticClass: "finishing-table",
              attrs: {
                data: _vm.shotsGrouped,
                size: "mini",
                id: _vm.tableElementId,
                "cell-style": { padding: "0" },
                "cell-class-name": `px-1 ${
                  _vm.darkMode ? "primary--text text-lighten-1" : ""
                }`,
              },
            },
            [
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "seasonName",
                    "class-name": "full-size-cell left",
                    align: "left",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (item) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-column pl-2 pr-2 text-ellipsis",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "body-2 primary--text text-ellipsis",
                                  class: {
                                    "font-weight-medium": item.row.seasonId,
                                    "font-weight-bold": !item.row.seasonId,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      item.row.seasonId
                                        ? _vm.formatLeagueLabelYear(item.row)
                                        : item.row.seasonName
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "d-flex align-center body-2" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(item.row.shots.length) +
                                        " " +
                                        _vm._s(_vm.$t("game.stats.shots"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  item.row.seasonId
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-center text-ellipsis",
                                        },
                                        [
                                          _c("span", { staticClass: "px-1" }, [
                                            _vm._v(" - "),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "text-ellipsis" },
                                            [_vm._v(_vm._s(item.row.teamName))]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("template", { slot: "header" }, [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column text-ellipsis" },
                      [
                        _vm.playerSeasonData[0]
                          ? _c("span", { staticClass: "text-ellipsis" }, [
                              _vm._v(
                                _vm._s(_vm.playerSeasonData[0].playerName)
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "body-2 text-ellipsis primary--text mt-n1",
                          },
                          [_vm._v(_vm._s(_vm.typeTitle))]
                        ),
                      ]
                    ),
                  ]),
                ],
                2
              ),
              _vm._v(" "),
              _vm.type === "xg"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "xg1",
                      label: "0,00 - 0,05 xG",
                      "label-class-name": "primary--text",
                      "class-name": "full-size-cell",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (item) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1",
                                  style: {
                                    "background-color":
                                      _vm.getBackgroundColorBlue(
                                        item.row,
                                        "xg",
                                        ["0", "0.05"]
                                      ),
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column flex-grow-1 text-ellipsis",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "body-2 primary--text font-weight-bold",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                (
                                                  (_vm.filterShots(
                                                    item.row.shots,
                                                    "xg",
                                                    "0",
                                                    "0.05"
                                                  ).length /
                                                    item.row.shots.length) *
                                                  100
                                                )
                                                  .toFixed(0)
                                                  .replace("NaN", 0)
                                              ) +
                                              "%\n                            "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-center text-ellipsis",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 text-ellipsis primary--text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.filterShots(
                                                    item.row.shots,
                                                    "xg",
                                                    "0",
                                                    "0.05"
                                                  ).length
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.$t("game.stats.shots")
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column align-center",
                                    },
                                    [
                                      _c("v-badge", {
                                        staticClass: "font-weight-bold",
                                        attrs: {
                                          inline: "",
                                          color: "black",
                                          "text-color": "white",
                                          content:
                                            _vm.filterShots(
                                              item.row.shots,
                                              "xg",
                                              "0",
                                              "0.05",
                                              true
                                            ).length || "0",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "black--text mt-n1",
                                          staticStyle: { "font-size": "10px" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "playerRecruitment.radarDescription.basicStatistics.goals"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      545040654
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "xg"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "xg2",
                      label: "0,05 - 0,10 xG",
                      "label-class-name": "primary--text",
                      "class-name": "full-size-cell",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (item) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1",
                                  style: {
                                    "background-color":
                                      _vm.getBackgroundColorBlue(
                                        item.row,
                                        "xg",
                                        ["0.05", "0.1"]
                                      ),
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column flex-grow-1 text-ellipsis",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "body-2 primary--text font-weight-bold",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                (
                                                  (_vm.filterShots(
                                                    item.row.shots,
                                                    "xg",
                                                    "0.05",
                                                    "0.1"
                                                  ).length /
                                                    item.row.shots.length) *
                                                  100
                                                )
                                                  .toFixed(0)
                                                  .replace("NaN", 0)
                                              ) +
                                              "%\n                            "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-center text-ellipsis",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 text-ellipsis primary--text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.filterShots(
                                                    item.row.shots,
                                                    "xg",
                                                    "0.05",
                                                    "0.1"
                                                  ).length
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.$t("game.stats.shots")
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column align-center",
                                    },
                                    [
                                      _c("v-badge", {
                                        staticClass: "font-weight-bold",
                                        attrs: {
                                          inline: "",
                                          color: "black",
                                          "text-color": "white",
                                          content:
                                            _vm.filterShots(
                                              item.row.shots,
                                              "xg",
                                              "0.05",
                                              "0.1",
                                              true
                                            ).length || "0",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "black--text mt-n1",
                                          staticStyle: { "font-size": "10px" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "playerRecruitment.radarDescription.basicStatistics.goals"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3825690158
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "xg"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "xg3",
                      label: "0,10 - 0,30 xG",
                      "label-class-name": "primary--text",
                      "class-name": "full-size-cell",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (item) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1",
                                  style: {
                                    "background-color":
                                      _vm.getBackgroundColorBlue(
                                        item.row,
                                        "xg",
                                        ["0.1", "0.3"]
                                      ),
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column flex-grow-1 text-ellipsis",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "body-2 primary--text font-weight-bold",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                (
                                                  (_vm.filterShots(
                                                    item.row.shots,
                                                    "xg",
                                                    "0.1",
                                                    "0.3"
                                                  ).length /
                                                    item.row.shots.length) *
                                                  100
                                                )
                                                  .toFixed(0)
                                                  .replace("NaN", 0)
                                              ) +
                                              "%\n                            "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-center text-ellipsis",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 text-ellipsis primary--text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.filterShots(
                                                    item.row.shots,
                                                    "xg",
                                                    "0.1",
                                                    "0.3"
                                                  ).length
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.$t("game.stats.shots")
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column align-center",
                                    },
                                    [
                                      _c("v-badge", {
                                        staticClass: "font-weight-bold",
                                        attrs: {
                                          inline: "",
                                          color: "black",
                                          "text-color": "white",
                                          content:
                                            _vm.filterShots(
                                              item.row.shots,
                                              "xg",
                                              "0.1",
                                              "0.3",
                                              true
                                            ).length || "0",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "black--text mt-n1",
                                          staticStyle: { "font-size": "10px" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "playerRecruitment.radarDescription.basicStatistics.goals"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1579793742
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "xg"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "xg4",
                      label: "0,30 - 1 xG",
                      "label-class-name": "primary--text",
                      "class-name": "full-size-cell",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (item) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1",
                                  style: {
                                    "background-color":
                                      _vm.getBackgroundColorBlue(
                                        item.row,
                                        "xg",
                                        ["0.3", "1"]
                                      ),
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column flex-grow-1 text-ellipsis",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "body-2 primary--text font-weight-bold",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                (
                                                  (_vm.filterShots(
                                                    item.row.shots,
                                                    "xg",
                                                    "0.3",
                                                    "1"
                                                  ).length /
                                                    item.row.shots.length) *
                                                  100
                                                )
                                                  .toFixed(0)
                                                  .replace("NaN", 0)
                                              ) +
                                              "%\n                            "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-center text-ellipsis",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 text-ellipsis primary--text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.filterShots(
                                                    item.row.shots,
                                                    "xg",
                                                    "0.3",
                                                    "1"
                                                  ).length
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.$t("game.stats.shots")
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column align-center",
                                    },
                                    [
                                      _c("v-badge", {
                                        staticClass: "font-weight-bold",
                                        attrs: {
                                          inline: "",
                                          color: "black",
                                          "text-color": "white",
                                          content:
                                            _vm.filterShots(
                                              item.row.shots,
                                              "xg",
                                              "0.3",
                                              "1",
                                              true
                                            ).length || "0",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "black--text mt-n1",
                                          staticStyle: { "font-size": "10px" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "playerRecruitment.radarDescription.basicStatistics.goals"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2919195406
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "typeShot"
                ? _c(
                    "el-table-column",
                    {
                      attrs: {
                        label: _vm.$t("finishingMap.onGoal"),
                        align: "center",
                        "class-name": "category-header text-ellipsis",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "typeShot1",
                          label: _vm.$t("finishingMap.goal"),
                          "label-class-name": "primary--text text-ellipsis",
                          "class-name": "full-size-cell",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (item) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1",
                                      style: {
                                        "background-color":
                                          _vm.getBackgroundColorBlue(
                                            item.row,
                                            "typeShot",
                                            ["GOAL", ""]
                                          ),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column flex-grow-1 text-ellipsis",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 primary--text font-weight-bold",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    (
                                                      (_vm.filterShots(
                                                        item.row.shots,
                                                        "typeShot",
                                                        "GOAL",
                                                        ""
                                                      ).length /
                                                        item.row.shots.length) *
                                                      100
                                                    )
                                                      .toFixed(0)
                                                      .replace("NaN", 0)
                                                  ) +
                                                  "%\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-center text-ellipsis",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 text-ellipsis primary--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.filterShots(
                                                        item.row.shots,
                                                        "typeShot",
                                                        "GOAL",
                                                        ""
                                                      ).length
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "game.stats.shots"
                                                        )
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          782546829
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "typeShot2",
                          label: _vm.$t("finishingMap.savedShot"),
                          "label-class-name": "primary--text text-ellipsis",
                          "class-name": "full-size-cell",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (item) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1",
                                      style: {
                                        "background-color":
                                          _vm.getBackgroundColorBlue(
                                            item.row,
                                            "typeShot",
                                            ["SAVED SHOT", ""]
                                          ),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column flex-grow-1 text-ellipsis",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 primary--text font-weight-bold",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    (
                                                      (_vm.filterShots(
                                                        item.row.shots,
                                                        "typeShot",
                                                        "SAVED SHOT",
                                                        ""
                                                      ).length /
                                                        item.row.shots.length) *
                                                      100
                                                    )
                                                      .toFixed(0)
                                                      .replace("NaN", 0)
                                                  ) +
                                                  "%\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-center text-ellipsis",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 text-ellipsis primary--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.filterShots(
                                                        item.row.shots,
                                                        "typeShot",
                                                        "SAVED SHOT",
                                                        ""
                                                      ).length
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "game.stats.shots"
                                                        )
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2044184717
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "typeShot"
                ? _c(
                    "el-table-column",
                    {
                      attrs: {
                        label: _vm.$t("finishingMap.outOfGoal"),
                        align: "center",
                        "class-name": "category-header text-ellipsis",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "typeShot3",
                          label: _vm.$t("finishingMap.missedShot"),
                          "label-class-name": "primary--text text-ellipsis",
                          "class-name": "full-size-cell",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (item) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1",
                                      style: {
                                        "background-color":
                                          _vm.getBackgroundColorBlue(
                                            item.row,
                                            "typeShot",
                                            ["MISSED SHOT", ""]
                                          ),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column flex-grow-1 text-ellipsis",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 primary--text font-weight-bold",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    (
                                                      (_vm.filterShots(
                                                        item.row.shots,
                                                        "typeShot",
                                                        "MISSED SHOT",
                                                        ""
                                                      ).length /
                                                        item.row.shots.length) *
                                                      100
                                                    )
                                                      .toFixed(0)
                                                      .replace("NaN", 0)
                                                  ) +
                                                  "%\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-center text-ellipsis",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 text-ellipsis primary--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.filterShots(
                                                        item.row.shots,
                                                        "typeShot",
                                                        "MISSED SHOT",
                                                        ""
                                                      ).length
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "game.stats.shots"
                                                        )
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          409982125
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "typeShot4",
                          label: _vm.$t("finishingMap.shotOnPost"),
                          "label-class-name": "primary--text text-ellipsis",
                          "class-name": "full-size-cell",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (item) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1",
                                      style: {
                                        "background-color":
                                          _vm.getBackgroundColorBlue(
                                            item.row,
                                            "typeShot",
                                            ["SHOT ON POST", ""]
                                          ),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column flex-grow-1 text-ellipsis",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 primary--text font-weight-bold",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    (
                                                      (_vm.filterShots(
                                                        item.row.shots,
                                                        "typeShot",
                                                        "SHOT ON POST",
                                                        ""
                                                      ).length /
                                                        item.row.shots.length) *
                                                      100
                                                    )
                                                      .toFixed(0)
                                                      .replace("NaN", 0)
                                                  ) +
                                                  "%\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-center text-ellipsis",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 text-ellipsis primary--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.filterShots(
                                                        item.row.shots,
                                                        "typeShot",
                                                        "SHOT ON POST",
                                                        ""
                                                      ).length
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "game.stats.shots"
                                                        )
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1578723185
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "shotStrategy"
                ? _c(
                    "el-table-column",
                    {
                      attrs: {
                        label: _vm.$t("finishingMap.openPlay"),
                        align: "center",
                        "class-name": "category-header text-ellipsis",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "shotStrategy1",
                          label: _vm.$t("finishingMap.regularPlay"),
                          "label-class-name": "primary--text text-ellipsis",
                          "class-name": "full-size-cell",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (item) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1",
                                      style: {
                                        "background-color":
                                          _vm.getBackgroundColorBlue(
                                            item.row,
                                            "shotStrategy",
                                            ["Regular play", ""]
                                          ),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column flex-grow-1 text-ellipsis",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 primary--text font-weight-bold",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    (
                                                      (_vm.filterShots(
                                                        item.row.shots,
                                                        "shotStrategy",
                                                        "Regular play",
                                                        ""
                                                      ).length /
                                                        item.row.shots.length) *
                                                      100
                                                    )
                                                      .toFixed(0)
                                                      .replace("NaN", 0)
                                                  ) +
                                                  "%\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-center text-ellipsis",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 text-ellipsis primary--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.filterShots(
                                                        item.row.shots,
                                                        "shotStrategy",
                                                        "Regular play",
                                                        ""
                                                      ).length
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "game.stats.shots"
                                                        )
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column align-center",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "black--text mt-n1",
                                              staticStyle: {
                                                "font-size": "10px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "playerRecruitment.radarDescription.basicStatistics.goals"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("v-badge", {
                                            staticClass: "font-weight-bold",
                                            attrs: {
                                              inline: "",
                                              color: "black",
                                              "text-color": "white",
                                              content:
                                                _vm.filterShots(
                                                  item.row.shots,
                                                  "shotStrategy",
                                                  "Regular play",
                                                  "",
                                                  true
                                                ).length || "0",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1958381390
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "shotStrategy2",
                          label: _vm.$t("finishingMap.fastBreak"),
                          "label-class-name": "primary--text text-ellipsis",
                          "class-name": "full-size-cell",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (item) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1",
                                      style: {
                                        "background-color":
                                          _vm.getBackgroundColorBlue(
                                            item.row,
                                            "shotStrategy",
                                            ["Fast break", ""]
                                          ),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column flex-grow-1 text-ellipsis",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 primary--text font-weight-bold",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    (
                                                      (_vm.filterShots(
                                                        item.row.shots,
                                                        "shotStrategy",
                                                        "Fast break",
                                                        ""
                                                      ).length /
                                                        item.row.shots.length) *
                                                      100
                                                    )
                                                      .toFixed(0)
                                                      .replace("NaN", 0)
                                                  ) +
                                                  "%\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-center text-ellipsis",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 text-ellipsis primary--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.filterShots(
                                                        item.row.shots,
                                                        "shotStrategy",
                                                        "Fast break",
                                                        ""
                                                      ).length
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "game.stats.shots"
                                                        )
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column align-center",
                                        },
                                        [
                                          _c("v-badge", {
                                            staticClass: "font-weight-bold",
                                            attrs: {
                                              inline: "",
                                              color: "black",
                                              "text-color": "white",
                                              content:
                                                _vm.filterShots(
                                                  item.row.shots,
                                                  "shotStrategy",
                                                  "Fast break",
                                                  "",
                                                  true
                                                ).length || "0",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "black--text mt-n1",
                                              staticStyle: {
                                                "font-size": "10px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "playerRecruitment.radarDescription.basicStatistics.goals"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1893852974
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "shotStrategy3",
                          label: _vm.$t("finishingMap.individualPlay"),
                          "label-class-name": "primary--text text-ellipsis",
                          "class-name": "full-size-cell",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (item) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1",
                                      style: {
                                        "background-color":
                                          _vm.getBackgroundColorBlue(
                                            item.row,
                                            "shotStrategy",
                                            ["Individual play", ""]
                                          ),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column flex-grow-1 text-ellipsis",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 primary--text font-weight-bold",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    (
                                                      (_vm.filterShots(
                                                        item.row.shots,
                                                        "shotStrategy",
                                                        "Individual play",
                                                        ""
                                                      ).length /
                                                        item.row.shots.length) *
                                                      100
                                                    )
                                                      .toFixed(0)
                                                      .replace("NaN", 0)
                                                  ) +
                                                  "%\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-center text-ellipsis",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 text-ellipsis primary--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.filterShots(
                                                        item.row.shots,
                                                        "shotStrategy",
                                                        "Individual play",
                                                        ""
                                                      ).length
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "game.stats.shots"
                                                        )
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column align-center",
                                        },
                                        [
                                          _c("v-badge", {
                                            staticClass: "font-weight-bold",
                                            attrs: {
                                              inline: "",
                                              color: "black",
                                              "text-color": "white",
                                              content:
                                                _vm.filterShots(
                                                  item.row.shots,
                                                  "shotStrategy",
                                                  "Individual play",
                                                  "",
                                                  true
                                                ).length || "0",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "black--text mt-n1",
                                              staticStyle: {
                                                "font-size": "10px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "playerRecruitment.radarDescription.basicStatistics.goals"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1529092750
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "shotStrategy"
                ? _c(
                    "el-table-column",
                    {
                      attrs: {
                        label: _vm.$t("finishingMap.setPiece"),
                        align: "center",
                        "class-name": "category-header text-ellipsis",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "shotStrategy4",
                          label: _vm.$t("finishingMap.freeKick"),
                          "label-class-name": "primary--text text-ellipsis",
                          "class-name": "full-size-cell",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (item) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1",
                                      style: {
                                        "background-color":
                                          _vm.getBackgroundColorBlue(
                                            item.row,
                                            "shotStrategy",
                                            ["Free kick", ""]
                                          ),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column flex-grow-1 text-ellipsis",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 primary--text font-weight-bold",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    (
                                                      (_vm.filterShots(
                                                        item.row.shots,
                                                        "shotStrategy",
                                                        "Free kick",
                                                        ""
                                                      ).length /
                                                        item.row.shots.length) *
                                                      100
                                                    )
                                                      .toFixed(0)
                                                      .replace("NaN", 0)
                                                  ) +
                                                  "%\n                                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-center text-ellipsis",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 text-ellipsis primary--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.filterShots(
                                                        item.row.shots,
                                                        "shotStrategy",
                                                        "Free kick",
                                                        ""
                                                      ).length
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "game.stats.shots"
                                                        )
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column align-center",
                                        },
                                        [
                                          _c("v-badge", {
                                            staticClass: "font-weight-bold",
                                            attrs: {
                                              inline: "",
                                              color: "black",
                                              "text-color": "white",
                                              content:
                                                _vm.filterShots(
                                                  item.row.shots,
                                                  "shotStrategy",
                                                  "Free kick",
                                                  "",
                                                  true
                                                ).length || "0",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "black--text mt-n1",
                                              staticStyle: {
                                                "font-size": "10px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "playerRecruitment.radarDescription.basicStatistics.goals"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3902629422
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "shotStrategy5",
                          label: _vm.$t("finishingMap.indirectFreeKick"),
                          "label-class-name": "primary--text text-ellipsis",
                          "class-name": "full-size-cell",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (item) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1",
                                      style: {
                                        "background-color":
                                          _vm.getBackgroundColorBlue(
                                            item.row,
                                            "shotStrategy",
                                            ["Indirect free kick", ""]
                                          ),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column flex-grow-1 text-ellipsis",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 primary--text font-weight-bold",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    (
                                                      (_vm.filterShots(
                                                        item.row.shots,
                                                        "shotStrategy",
                                                        "Indirect free kick",
                                                        ""
                                                      ).length /
                                                        item.row.shots.length) *
                                                      100
                                                    )
                                                      .toFixed(0)
                                                      .replace("NaN", 0)
                                                  ) +
                                                  "%\n                                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-center text-ellipsis",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 text-ellipsis primary--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.filterShots(
                                                        item.row.shots,
                                                        "shotStrategy",
                                                        "Indirect free kick",
                                                        ""
                                                      ).length
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "game.stats.shots"
                                                        )
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column align-center",
                                        },
                                        [
                                          _c("v-badge", {
                                            staticClass: "font-weight-bold",
                                            attrs: {
                                              inline: "",
                                              color: "black",
                                              "text-color": "white",
                                              content:
                                                _vm.filterShots(
                                                  item.row.shots,
                                                  "shotStrategy",
                                                  "Indirect free kick",
                                                  "",
                                                  true
                                                ).length || "0",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "black--text mt-n1",
                                              staticStyle: {
                                                "font-size": "10px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "playerRecruitment.radarDescription.basicStatistics.goals"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1130746062
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "shotStrategy6",
                          label: _vm.$t("finishingMap.fromCorner"),
                          "label-class-name": "primary--text text-ellipsis",
                          "class-name": "full-size-cell",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (item) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1",
                                      style: {
                                        "background-color":
                                          _vm.getBackgroundColorBlue(
                                            item.row,
                                            "shotStrategy",
                                            ["From corner", ""]
                                          ),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column flex-grow-1 text-ellipsis",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 primary--text font-weight-bold",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    (
                                                      (_vm.filterShots(
                                                        item.row.shots,
                                                        "shotStrategy",
                                                        "From corner",
                                                        ""
                                                      ).length /
                                                        item.row.shots.length) *
                                                      100
                                                    )
                                                      .toFixed(0)
                                                      .replace("NaN", 0)
                                                  ) +
                                                  "%\n                                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-center text-ellipsis",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 text-ellipsis primary--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.filterShots(
                                                        item.row.shots,
                                                        "shotStrategy",
                                                        "From corner",
                                                        ""
                                                      ).length
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "game.stats.shots"
                                                        )
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column align-center",
                                        },
                                        [
                                          _c("v-badge", {
                                            staticClass: "font-weight-bold",
                                            attrs: {
                                              inline: "",
                                              color: "black",
                                              "text-color": "white",
                                              content:
                                                _vm.filterShots(
                                                  item.row.shots,
                                                  "shotStrategy",
                                                  "From corner",
                                                  "",
                                                  true
                                                ).length || "0",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "black--text mt-n1",
                                              staticStyle: {
                                                "font-size": "10px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "playerRecruitment.radarDescription.basicStatistics.goals"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2083172814
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "shotStrategy7",
                          label: _vm.$t("finishingMap.throwInSetPiece"),
                          "label-class-name": "primary--text text-ellipsis",
                          "class-name": "full-size-cell",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (item) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1",
                                      style: {
                                        "background-color":
                                          _vm.getBackgroundColorBlue(
                                            item.row,
                                            "shotStrategy",
                                            ["Throw in set piece", ""]
                                          ),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column flex-grow-1 text-ellipsis",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 primary--text font-weight-bold",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    (
                                                      (_vm.filterShots(
                                                        item.row.shots,
                                                        "shotStrategy",
                                                        "Throw in set piece",
                                                        ""
                                                      ).length /
                                                        item.row.shots.length) *
                                                      100
                                                    )
                                                      .toFixed(0)
                                                      .replace("NaN", 0)
                                                  ) +
                                                  "%\n                                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-center text-ellipsis",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 text-ellipsis primary--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.filterShots(
                                                        item.row.shots,
                                                        "shotStrategy",
                                                        "Throw in set piece",
                                                        ""
                                                      ).length
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "game.stats.shots"
                                                        )
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column align-center",
                                        },
                                        [
                                          _c("v-badge", {
                                            staticClass: "font-weight-bold",
                                            attrs: {
                                              inline: "",
                                              color: "black",
                                              "text-color": "white",
                                              content:
                                                _vm.filterShots(
                                                  item.row.shots,
                                                  "shotStrategy",
                                                  "Throw in set piece",
                                                  "",
                                                  true
                                                ).length || "0",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "black--text mt-n1",
                                              staticStyle: {
                                                "font-size": "10px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "playerRecruitment.radarDescription.basicStatistics.goals"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3366082478
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "area"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "area1",
                      label: _vm.$t("finishingMap.goalArea"),
                      "label-class-name": "primary--text",
                      "class-name": "full-size-cell",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (item) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1",
                                  style: {
                                    "background-color":
                                      _vm.getBackgroundColorBlue(
                                        item.row,
                                        "area",
                                        [["goalArea"], ""]
                                      ),
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column flex-grow-1 text-ellipsis",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "body-2 primary--text font-weight-bold",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                (
                                                  (_vm.filterShots(
                                                    item.row.shots,
                                                    "area",
                                                    ["goalArea"],
                                                    ""
                                                  ).length /
                                                    item.row.shots.length) *
                                                  100
                                                )
                                                  .toFixed(0)
                                                  .replace("NaN", 0)
                                              ) +
                                              "%\n                            "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-center text-ellipsis",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 text-ellipsis primary--text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.filterShots(
                                                    item.row.shots,
                                                    "area",
                                                    ["goalArea"],
                                                    ""
                                                  ).length
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.$t("game.stats.shots")
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column align-center",
                                    },
                                    [
                                      _c("v-badge", {
                                        staticClass: "font-weight-bold",
                                        attrs: {
                                          inline: "",
                                          color: "black",
                                          "text-color": "white",
                                          content:
                                            _vm.filterShots(
                                              item.row.shots,
                                              "area",
                                              ["goalArea"],
                                              "",
                                              true
                                            ).length || "0",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "black--text mt-n1",
                                          staticStyle: { "font-size": "10px" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "playerRecruitment.radarDescription.basicStatistics.goals"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2189032590
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "area"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "area2",
                      label: _vm.$t("finishingMap.inBox"),
                      "label-class-name": "primary--text",
                      "class-name": "full-size-cell",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (item) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1",
                                  style: {
                                    "background-color":
                                      _vm.getBackgroundColorBlue(
                                        item.row,
                                        "area",
                                        [
                                          ["boxRight", "boxLeft", "boxCenter"],
                                          "",
                                        ]
                                      ),
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column flex-grow-1 text-ellipsis",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "body-2 primary--text font-weight-bold",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                (
                                                  (_vm.filterShots(
                                                    item.row.shots,
                                                    "area",
                                                    [
                                                      "boxRight",
                                                      "boxLeft",
                                                      "boxCenter",
                                                    ],
                                                    ""
                                                  ).length /
                                                    item.row.shots.length) *
                                                  100
                                                )
                                                  .toFixed(0)
                                                  .replace("NaN", 0)
                                              ) +
                                              "%\n                            "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-center text-ellipsis",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 text-ellipsis primary--text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.filterShots(
                                                    item.row.shots,
                                                    "area",
                                                    [
                                                      "boxRight",
                                                      "boxLeft",
                                                      "boxCenter",
                                                    ],
                                                    ""
                                                  ).length
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.$t("game.stats.shots")
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column align-center",
                                    },
                                    [
                                      _c("v-badge", {
                                        staticClass: "font-weight-bold",
                                        attrs: {
                                          inline: "",
                                          color: "black",
                                          "text-color": "white",
                                          content:
                                            _vm.filterShots(
                                              item.row.shots,
                                              "area",
                                              [
                                                "boxRight",
                                                "boxLeft",
                                                "boxCenter",
                                              ],
                                              "",
                                              true
                                            ).length || "0",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "black--text mt-n1",
                                          staticStyle: { "font-size": "10px" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "playerRecruitment.radarDescription.basicStatistics.goals"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      603029294
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "area"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "area3",
                      label: _vm.$t("finishingMap.outOfBox"),
                      "label-class-name": "primary--text",
                      "class-name": "full-size-cell",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (item) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1",
                                  style: {
                                    "background-color":
                                      _vm.getBackgroundColorBlue(
                                        item.row,
                                        "area",
                                        [
                                          [
                                            "outBoxDeepRight",
                                            "outBoxDeepLeft",
                                            "outBoxRight",
                                            "outBoxCentreRight",
                                            "outBoxCentre",
                                            "outBoxCentreLeft",
                                            "outBoxLeft",
                                            "right35",
                                            "centreRight35",
                                            "centre35",
                                            "centreLeft35",
                                            "left35",
                                          ],
                                          "",
                                        ]
                                      ),
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column flex-grow-1 text-ellipsis",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "body-2 primary--text font-weight-bold",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                (
                                                  (_vm.filterShots(
                                                    item.row.shots,
                                                    "area",
                                                    [
                                                      "outBoxDeepRight",
                                                      "outBoxDeepLeft",
                                                      "outBoxRight",
                                                      "outBoxCentreRight",
                                                      "outBoxCentre",
                                                      "outBoxCentreLeft",
                                                      "outBoxLeft",
                                                      "right35",
                                                      "centreRight35",
                                                      "centre35",
                                                      "centreLeft35",
                                                      "left35",
                                                    ],
                                                    ""
                                                  ).length /
                                                    item.row.shots.length) *
                                                  100
                                                )
                                                  .toFixed(0)
                                                  .replace("NaN", 0)
                                              ) +
                                              "%\n                            "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-center text-ellipsis",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 text-ellipsis primary--text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.filterShots(
                                                    item.row.shots,
                                                    "area",
                                                    [
                                                      "outBoxDeepRight",
                                                      "outBoxDeepLeft",
                                                      "outBoxRight",
                                                      "outBoxCentreRight",
                                                      "outBoxCentre",
                                                      "outBoxCentreLeft",
                                                      "outBoxLeft",
                                                      "right35",
                                                      "centreRight35",
                                                      "centre35",
                                                      "centreLeft35",
                                                      "left35",
                                                    ],
                                                    ""
                                                  ).length
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.$t("game.stats.shots")
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column align-center",
                                    },
                                    [
                                      _c("v-badge", {
                                        staticClass: "font-weight-bold",
                                        attrs: {
                                          inline: "",
                                          color: "black",
                                          "text-color": "white",
                                          content:
                                            _vm.filterShots(
                                              item.row.shots,
                                              "area",
                                              [
                                                "outBoxDeepRight",
                                                "outBoxDeepLeft",
                                                "outBoxRight",
                                                "outBoxCentreRight",
                                                "outBoxCentre",
                                                "outBoxCentreLeft",
                                                "outBoxLeft",
                                                "right35",
                                                "centreRight35",
                                                "centre35",
                                                "centreLeft35",
                                                "left35",
                                              ],
                                              "",
                                              true
                                            ).length || "0",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "black--text mt-n1",
                                          staticStyle: { "font-size": "10px" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "playerRecruitment.radarDescription.basicStatistics.goals"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      20140430
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "bodyPart"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "bodyPart1",
                      label: _vm.$t("finishingMap.leftFooted"),
                      "label-class-name": "primary--text",
                      "class-name": "full-size-cell",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (item) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1",
                                  style: {
                                    "background-color":
                                      _vm.getBackgroundColorBlue(
                                        item.row,
                                        "bodyPart",
                                        ["Left footed", ""]
                                      ),
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column flex-grow-1 text-ellipsis",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "body-2 primary--text font-weight-bold",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                (
                                                  (_vm.filterShots(
                                                    item.row.shots,
                                                    "bodyPart",
                                                    "Left footed",
                                                    ""
                                                  ).length /
                                                    item.row.shots.length) *
                                                  100
                                                )
                                                  .toFixed(0)
                                                  .replace("NaN", 0)
                                              ) +
                                              "%\n                            "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-center text-ellipsis",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 text-ellipsis primary--text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.filterShots(
                                                    item.row.shots,
                                                    "bodyPart",
                                                    "Left footed",
                                                    ""
                                                  ).length
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.$t("game.stats.shots")
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column align-center",
                                    },
                                    [
                                      _c("v-badge", {
                                        staticClass: "font-weight-bold",
                                        attrs: {
                                          inline: "",
                                          color: "black",
                                          "text-color": "white",
                                          content:
                                            _vm.filterShots(
                                              item.row.shots,
                                              "bodyPart",
                                              "Left footed",
                                              "",
                                              true
                                            ).length || "0",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "black--text mt-n1",
                                          staticStyle: { "font-size": "10px" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "playerRecruitment.radarDescription.basicStatistics.goals"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      530481774
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "bodyPart"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "bodyPart2",
                      label: _vm.$t("finishingMap.rightFooted"),
                      "label-class-name": "primary--text",
                      "class-name": "full-size-cell",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (item) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1",
                                  style: {
                                    "background-color":
                                      _vm.getBackgroundColorBlue(
                                        item.row,
                                        "bodyPart",
                                        ["Right footed", ""]
                                      ),
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column flex-grow-1 text-ellipsis",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "body-2 primary--text font-weight-bold",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                (
                                                  (_vm.filterShots(
                                                    item.row.shots,
                                                    "bodyPart",
                                                    "Right footed",
                                                    ""
                                                  ).length /
                                                    item.row.shots.length) *
                                                  100
                                                )
                                                  .toFixed(0)
                                                  .replace("NaN", 0)
                                              ) +
                                              "%\n                            "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-center text-ellipsis",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 text-ellipsis primary--text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.filterShots(
                                                    item.row.shots,
                                                    "bodyPart",
                                                    "Right footed",
                                                    ""
                                                  ).length
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.$t("game.stats.shots")
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column align-center",
                                    },
                                    [
                                      _c("v-badge", {
                                        staticClass: "font-weight-bold",
                                        attrs: {
                                          inline: "",
                                          color: "black",
                                          "text-color": "white",
                                          content:
                                            _vm.filterShots(
                                              item.row.shots,
                                              "bodyPart",
                                              "Right footed",
                                              "",
                                              true
                                            ).length || "0",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "black--text mt-n1",
                                          staticStyle: { "font-size": "10px" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "playerRecruitment.radarDescription.basicStatistics.goals"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2886009326
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "bodyPart"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "bodyPart3",
                      label: _vm.$t("finishingMap.head"),
                      "label-class-name": "primary--text",
                      "class-name": "full-size-cell",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (item) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1",
                                  style: {
                                    "background-color":
                                      _vm.getBackgroundColorBlue(
                                        item.row,
                                        "bodyPart",
                                        ["Head", ""]
                                      ),
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column flex-grow-1 text-ellipsis",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "body-2 primary--text font-weight-bold",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                (
                                                  (_vm.filterShots(
                                                    item.row.shots,
                                                    "bodyPart",
                                                    "Head",
                                                    ""
                                                  ).length /
                                                    item.row.shots.length) *
                                                  100
                                                )
                                                  .toFixed(0)
                                                  .replace("NaN", 0)
                                              ) +
                                              "%\n                            "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-center text-ellipsis",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 text-ellipsis primary--text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.filterShots(
                                                    item.row.shots,
                                                    "bodyPart",
                                                    "Head",
                                                    ""
                                                  ).length
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.$t("game.stats.shots")
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column align-center",
                                    },
                                    [
                                      _c("v-badge", {
                                        staticClass: "font-weight-bold",
                                        attrs: {
                                          inline: "",
                                          color: "black",
                                          "text-color": "white",
                                          content:
                                            _vm.filterShots(
                                              item.row.shots,
                                              "bodyPart",
                                              "Head",
                                              "",
                                              true
                                            ).length || "0",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "black--text mt-n1",
                                          staticStyle: { "font-size": "10px" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "playerRecruitment.radarDescription.basicStatistics.goals"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      45749454
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "bodyPart"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "bodyPart4",
                      label: _vm.$t("finishingMap.otherBodyPart"),
                      "label-class-name": "primary--text",
                      "class-name": "full-size-cell",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (item) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1",
                                  style: {
                                    "background-color":
                                      _vm.getBackgroundColorBlue(
                                        item.row,
                                        "bodyPart",
                                        ["Other body part", ""]
                                      ),
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column flex-grow-1 text-ellipsis",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "body-2 primary--text font-weight-bold",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                (
                                                  (_vm.filterShots(
                                                    item.row.shots,
                                                    "bodyPart",
                                                    "Other body part",
                                                    ""
                                                  ).length /
                                                    item.row.shots.length) *
                                                  100
                                                )
                                                  .toFixed(0)
                                                  .replace("NaN", 0)
                                              ) +
                                              "%\n                            "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-center text-ellipsis",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 text-ellipsis primary--text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.filterShots(
                                                    item.row.shots,
                                                    "bodyPart",
                                                    "Other body part",
                                                    ""
                                                  ).length
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.$t("game.stats.shots")
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column align-center",
                                    },
                                    [
                                      _c("v-badge", {
                                        staticClass: "font-weight-bold",
                                        attrs: {
                                          inline: "",
                                          color: "black",
                                          "text-color": "white",
                                          content:
                                            _vm.filterShots(
                                              item.row.shots,
                                              "bodyPart",
                                              "Other body part",
                                              "",
                                              true
                                            ).length || "0",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "black--text mt-n1",
                                          staticStyle: { "font-size": "10px" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "playerRecruitment.radarDescription.basicStatistics.goals"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      166675854
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }